import { Injectable } from '@angular/core';
import { CommercialListApiService } from '@epicuro-next/data/engagement/engagement-api';
import { EngagementCommercialListGetDeliveryInfoResponse } from '@epicuro-next/data/engagement/engagement-models';
import { selectActiveAccountId } from '@epicuro-next/state/accounts-state';
import { isNonNullish } from '@epicuro-next/utilities';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import {
  catchError,
  filter,
  map,
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';

import { mapProductReferencesToListProductEntity } from '../utils';

import {
  loadListProductReferences,
  upsertListProductReferenceEntity,
} from './list-product-reference-entities.actions';

const LOAD_ERROR = $localize`:ListProductReference|Failed to fetch list delivery info@@listProductReferenceError:Failed to fetch delivery information for this basket.`;

@Injectable()
export class ListProductReferenceEntitiesEffects {
  public accountId$ = this.store.pipe(
    select(selectActiveAccountId),
    filter(isNonNullish),
  );

  public requestListDeliveryInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadListProductReferences),
      withLatestFrom(this.accountId$),
      switchMap(([{ productListId }]) =>
        this.commercialListService
          .checkDeliveryInfo({
            productListId,
          })
          .pipe(
            map(
              ({
                currency,
                products,
              }: EngagementCommercialListGetDeliveryInfoResponse) =>
                upsertListProductReferenceEntity({
                  productReferenceEntity: {
                    ...mapProductReferencesToListProductEntity(
                      productListId,
                      currency,
                      products,
                    ),
                    loading: false,
                  },
                }),
            ),
            catchError(() => [
              upsertListProductReferenceEntity({
                productReferenceEntity: {
                  listId: productListId,
                  loading: false,
                  error: LOAD_ERROR,
                },
              }),
            ]),
          ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store,
    private commercialListService: CommercialListApiService,
  ) {}
}
